import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
export default {
  name: 'EditorialOpenGraph',
  props: {
    edito: {
      type: Object,
      required: true
    },
    slices: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  })), {}, {
    title() {
      var _ref6, _ref7;
      var title = ((_ref7 = this.edito) != null ? _ref7.og_title : _ref7) || ((_ref6 = this.edito) != null ? _ref6.meta_title : _ref6);
      return title ? "".concat(title, " | Maisons du Monde") : 'Maisons du Monde';
    },
    description() {
      var _ref4, _ref5;
      return ((_ref5 = this.edito) != null ? _ref5.og_description : _ref5) || ((_ref4 = this.edito) != null ? _ref4.meta_description : _ref4) || '';
    },
    url() {
      var _ref3;
      return ((_ref3 = this.edito) != null ? (_ref3 = _ref3.canonical) != null ? _ref3.url : _ref3 : _ref3) || '';
    },
    image() {
      var _ref2;
      return ((_ref2 = this.edito) != null ? (_ref2 = _ref2.og_image) != null ? _ref2.url : _ref2 : _ref2) || '';
    },
    date() {
      var _ref;
      return ((_ref = this.edito) != null ? _ref.date : _ref) || '';
    }
  }),
  head() {
    var meta = [{
      property: 'og:title',
      content: this.title
    }, {
      property: 'og:description',
      content: this.description
    }, {
      property: 'og:url',
      content: this.url
    }, {
      property: 'og:locale',
      content: this.locale.iso
    }];
    if (this.image) meta.push({
      property: 'og:image',
      content: this.image
    });
    if (this.type === 'article') meta.push({
      property: 'og:type',
      content: 'article'
    });
    if (this.type === 'article') meta.push({
      property: 'article:published_time',
      content: this.date
    });
    return {
      meta
    };
  },
  render: h => h(null)
};